import type { Event } from 'models';
import { useCallback } from 'react';
import type { AttachmentsFormContentValues } from '../components';
import { useDeleteEventAttachment } from '../queries';

type DeleteEventAttachmentsParams = {
  event: Event;
  formAttachments: AttachmentsFormContentValues['attachments'];
};

export const useDeleteEventAttachments = () => {
  const { isPending, mutateAsync: deleteEventAttachment } = useDeleteEventAttachment();

  const deleteEventAttachments = useCallback(
    async ({ event: { id, preloadedFiles }, formAttachments }: DeleteEventAttachmentsParams) => {
      const attachmentsToDelete = preloadedFiles?.filter(
        (attachment) => !formAttachments?.fileList.some((file) => file.uid === attachment.id),
      );

      if (!attachmentsToDelete || attachmentsToDelete.length === 0) {
        return;
      }

      await Promise.all(
        attachmentsToDelete.map(async (attachment) =>
          deleteEventAttachment({ attachmentId: attachment.id, eventId: id }),
        ),
      );
    },
    [deleteEventAttachment],
  );

  return {
    deleteEventAttachments,
    isDeletingAttachments: isPending,
  };
};
